import { ANALYTIC_COOKIES } from './constants'
import {
  getUtmValues,
  initAnalyticsCookieFromCrossPlatformData,
} from './cross-platform-analytics/cross-platform-analytics.utils'
import getCurrentUser from './getCurrentUser'
import { getlbUserId } from './getlb-user-id'
import isBrowser from './isBrowser'
import setCookie from './setCookie'

function initUserAnalyticsCookie() {
  if (!isBrowser()) return
  initAnalyticsCookieFromCrossPlatformData()
  const { utmCampaign, utmContent, utmMedium, utmSource, utmTerm } = getUtmValues()

  const user = getCurrentUser()
  if (user?.email) {
    setCookie(ANALYTIC_COOKIES.LB_CUSTOMER_EMAIL, user.email)
  }
  if (utmMedium) {
    setCookie(ANALYTIC_COOKIES.UTM_MEDIUM, utmMedium, 120)
  }
  if (utmSource) {
    setCookie(ANALYTIC_COOKIES.UTM_SOURCE, utmSource, 120)
  }

  if (utmContent) {
    setCookie(ANALYTIC_COOKIES.UTM_CONTENT, utmContent, 120)
  }

  if (utmCampaign) {
    setCookie(ANALYTIC_COOKIES.UTM_CAMPAIGN, utmCampaign, 120)
  }

  if (utmTerm) {
    setCookie(ANALYTIC_COOKIES.UTM_TERM, utmTerm, 120)
  }

  getlbUserId()
}
export default initUserAnalyticsCookie
